<template>
  <div>
    <Modal v-model="isShowModal" :title="title" @on-cancel="hide('formValidate')" :mask-closable="false"
           width="800">

      <Divider orientation="left">申请信息</Divider>
      <Row :gutter="16">
        <Col span="8">
          <div>客户姓名：{{ userAddress.realName ? userAddress.realName : '-' }}</div>
        </Col>
        <Col span="8">
          <div>联系方式：{{ userAddress.mobile ? userAddress.mobile : '-' }}</div>
        </Col>
        <Col span="8">
          <div>审核状态：

            <template v-if="apply.state === 0">待审核</template>
            <template v-if="apply.state === 1">已通过</template>
            <template v-if="apply.state === 2">已拒绝</template>
          </div>
        </Col>
      </Row>
      <Row :gutter="16">
        <Col span="16">
          <div>门店地址：{{ userAddress.locationAddress }} {{ userAddress.address }}</div>
        </Col>
      </Row>
      <Row :gutter="16">
        <Col span="16">
          <div>备注：{{ apply.remark }}</div>
        </Col>
      </Row>
      <Row :gutter="16" v-if="apply.state == 2">
        <Col span="16">
          <div>审核理由：{{ apply.reason }}</div>
        </Col>
      </Row>
      <Divider orientation="left">门头照：</Divider>
      <div class="jw-images-row" v-if="apply.headImgList.length > 0">
        <img class="jw-image" v-for="(item,index) in apply.headImgList" :src="item"
             @click="showImg(index)">
      </div>

      <viewer :images="images" class="viewer" ref="viewer" @inited="inited" v-show="showImage">
        <template scope="scope">
          <img v-for="src in scope.images" :src="src" :key="src">
          {{ scope.options }}
        </template>
      </viewer>

      <!-- 重写对话框底部按钮 -->
      <div slot="footer">
<!--        <Button type="success" v-if="apply.state === 0" @click="examine">通过</Button>-->
<!--        <Button type="error" v-if="apply.state === 0" @click="">拒绝</Button>-->
        <Button @click="hide('formValidate')">取消</Button>
        <Button v-if="type != 1" type="primary" @click="hide('formValidate')" :loading="loadingBtn">
          <span v-if="!loadingBtn">确定</span>
          <span v-else>请稍候...</span>
        </Button>
      </div>
    </Modal>
  </div>
</template>

<script>
// import { Input } from 'view-ui-plus';
export default {
  data() {
    return {
      isShowModal: false,
      loadingBtn: false,
      title: '查看信息',
      type: 0,
      images: [],
      apply: {
        feedbackImg: []
      },
      userAddress: {},
      showImage: false,
      isState: false
    }
  },
  methods: {
    // 显示模态框
    show(type, row) {
      this.isShowModal = true;
      this.type = type;
      this.title = '查看';
      this.findFeedbackById(row);
    },
    // 查询投诉及意见详情
    findFeedbackById(row) {
      this.$Spin.show();
      this.axios.post('/userStarApply/getInfo', {
        applyId: row.applyId
      }).then(res => {
        console.log(res);
        setTimeout(() => {
          this.$Spin.hide();
        }, 300);
        if (res.status == 200) {
          this.apply = res.data.apply;
          this.userAddress = res.data.userAddress;
          if (res.data.apply.headImg) {
            this.apply.headImgList = res.data.apply.headImg.split(',');
            this.images = this.apply.headImgList;
          }
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查看星标申请详情接口报错',
            duration: 0
          });
        }
      })
    },
    inited(viewer) {
      this.$viewer = viewer
    },
    showImg(index) {
      console.log(index)
      this.$viewer.show();
    },
    // 关闭模态框
    hide(name) {
      this.isShowModal = false;
      // this.$refs[name].resetFields();
    },
    examine(row, flag) {
      this.isState = true
      // this.isShowModal = false
      // this.$Modal.confirm({
      //   title: `是否${flag ? '通过' : '拒绝'}用户${row.nickName}的申请？`,
      //   onOk: () => {
      //     this.examineApply(row, flag);
      //   },
      //   onCancel: () => {
      //     this.$Message.info('您点击了取消.');
      //   }
      // });
    },

  },
}
</script>

<style scoped>
.jw-images-row {
  display: flex;
  align-items: center;
}

.jw-image {
  width: 150px;
  height: 150px;
  margin-right: 10px;
}
</style>
